import { AdTabProps } from "./tab";

enum AdTabsEnum {
  LiveSex="LiveSex",
  RedGIFsAI="RedGIFsAI",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
}

export const tabs: AdTabsProps = {
  [AdTabsEnum.LiveSex]: {
    link: "https://rgcams.com/landing/click/?AFNO=1-1",
  },
  [AdTabsEnum.RedGIFsAI]: {
    link: "https://redgifs.ai/?utm_source=redgifs.com&utm_medium=header_button&utm_campaign=launch&utm_content=desktop",
  },
};
